
export default {
  inject: ['wizard'],

  created() {
    if (!this.wizard) {
      throw new Error('WizardSteps must be a descendant of a Wizard')
    }
  },
}
